import { useAuthStore } from '~/stores/useAuthStore'
import { isDashboardPathAllowed, practiceHomePath } from '~/utils/practice/roles'

/**
 * Guard for /dashboard/** routes. Uses the sealed session cookie (SSR-safe).
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.startsWith('/dashboard')) return

  const { loggedIn, fetch } = useUserSession()
  const auth = useAuthStore()
  await fetch()
  if (!loggedIn.value) {
    return navigateTo('/auth/login')
  }

  if (!auth.hydrated || !auth.isAuthenticated) {
    await auth.hydrate()
  }

  if (!auth.isAuthenticated) {
    return navigateTo('/auth/login')
  }

  const role = auth.user?.siteRole
  if (role === 'secretary' || role === 'doctor') {
    const path = to.path.replace(/\/$/, '') || '/dashboard'
    if (path === '/dashboard') return navigateTo(practiceHomePath(role, auth.user?.permissions))
    if (!isDashboardPathAllowed(role, path, auth.user?.permissions)) {
      return navigateTo(practiceHomePath(role, auth.user?.permissions))
    }
  }
})
